import { render, staticRenderFns } from "./OrdemDeServicoView.vue?vue&type=template&id=b753bd4e"
import script from "./OrdemDeServicoView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemDeServicoView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports